<template>
<div v-if="ligneCommande && ligneCommande.produit" class='commandes__produits'>
  <div class="commandes__details commandes__ligne--border-width">

    <div class='produit-associe'>
        <b-field :label="isFirstLigne($t('detail.article.productAssocie'))"
          custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <b-autocomplete
            :placeholder="$t('detail.article.search')"
            v-model="ligneCommande.produit.reference"
            :keep-first="keepFirst"
            :open-on-focus="openOnFocus"
            :data="typesProduit"
            field="produit.reference"
            :disabled="disabled || ligneCommande.calculAutomatiqueTlpe || isCommandeAchatBailleur"
            @select="selectedProduct"
            @input="searchProduct()">
            <template slot="empty">
              <div v-if="fetched">{{$t('detail.article.noResult')}}</div>
              <div v-else>{{$t('detail.article.search')}}</div>
            </template>
            <template slot-scope="props">
              {{ props.option.title }}
            </template>
          </b-autocomplete>
        </b-field>
    </div>

    <div class='libelle pdl-10px'>
        <b-field :label="isFirstLigne($t('detail.article.libelle'))"
        custom-class="is-size-7 is-marginless has-text-link ellipsis">
        <b-input v-model="ligneCommande.libelle" type="textarea"
          :disabled="disabled" :rows="nbLignesLibelle">
        </b-input>
      </b-field>
    </div>

    <div class="fields">

      <div class='pdl-10px'>
        <b-field :label="isFirstLigne($t('detail.article.quantite'))"
          custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <b-field style='--width: 60px;' class="is-marginless is-paddingless">
            <input-currency style='--width: 60px;' ref="quantite" v-model="ligneCommande.quantite"
              isNumber="true"
              :peutEtreNegatif="true"
              :disabled="ligneCommande.calculAutomatiqueTlpe || disabled"
              @input="calcul()">
            </input-currency>
            <p class="control" style='--width: 50px;'>
              <b-dropdown position="is-bottom-left"
                :disabled="ligneCommande.calculAutomatiqueTlpe || disabled">
                <button class="button select pdl-5px" slot="trigger">
                  <span class='is-pulled-left'>{{$t(unite)}}</span>
                </button>
                <b-dropdown-item v-for="unite in listeUniteQuantite"
                  :key="unite.code"
                  v-model="unite.code"
                  @click="changerUnite(unite)">
                  {{$t(unite.initiale)}} ({{$t(unite.libelle)}})
                </b-dropdown-item>
              </b-dropdown>
            </p>
          </b-field>
        </b-field>
      </div>

      <div class="pdl-10px">
        <b-field :label="isFirstLigne($t('detail.article.priceUnit'))"
                 custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <input-currency
            style='--width: 80px;'
            :disabled="ligneCommande.calculAutomatiqueTlpe || disabled"
            ref="prixUnitaire" v-model="ligneCommande.prixUnitaire"
            isNumber="true"
            :peutEtreNegatif="true"
            @input="calcul()">
          </input-currency>
          <b-dropdown position="is-bottom-left" style='--width: 40px;'
                      :disabled="ligneCommande.calculAutomatiqueTlpe || disabled">
            <button class="button select" slot="trigger">
            </button>
            <b-dropdown-item @click="openPopUpCalculette = true">
              {{ $t('dcf.calculette.actions.calculette') }}
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>

      <div class="pdl-10px">
        <b-field :label="isFirstLigne($t('detail.article.montantBrut'))"
                 custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <input-currency
            style='--width: 70px;'
            disabled
            ref="montantBrut" :value="getMontantBrut(ligneCommande)"
            isNumber="true"
            :peutEtreNegatif="true">
          </input-currency>
        </b-field>
      </div>

      <div class='pdl-10px'>
        <b-field :label="isFirstLigne($t('detail.article.discount'))"
          custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <b-field>
            <input-currency ref="remise" v-model="valeurPourcentage"
              isNumber="true" style='--width: 52px;'
              @input="calcul()"
              :disabled="estRemisePersonalisee()
                || isProduitPresse
                || ligneCommande.calculAutomatiqueTlpe
                || disabled">
            </input-currency>
            <b-dropdown position="is-bottom-left" style='--width: 55px;'
                        :disabled="ligneCommande.calculAutomatiqueTlpe || disabled">
              <button class="button select pdl-5px" slot="trigger">
                <span class='is-pulled-left'>{{$t(typeRemiseInitial)}}</span>
              </button>
              <b-dropdown-item v-for="typeRemise in getListeTypeRemise"
                :key="typeRemise.code"
                v-model="typeRemise.code"
                @click="changerTypeRemise(typeRemise)">
                {{$t(typeRemise.libelle)}}
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </b-field>
      </div>

      <div class="pdl-10px">
        <b-field :label="isFirstLigne($t('detail.article.prixUnitaireNet'))"
                 custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <input-currency
            style='--width: 70px;'
            disabled
            :value="getPrixUnitaireNet(ligneCommande)"
            isNumber="true"
            :peutEtreNegatif="true">
          </input-currency>
        </b-field>
      </div>

      <div class='pdl-10px'>
        <b-field :label="isFirstLigne($t('detail.article.TauxTva'))"
          custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <div class="select">
            <select ref="tauxTva" v-model="ligneCommande.tauxTva" v-on:change="changeTva"
              :disabled="isCreditNote || annonceurWithExonerationTva(ligneCommande) || disabled
              || ligneCommande.calculAutomatiqueTlpe">
              <option v-for="tva in regimeTva"
                      :key="tva.tauxTva"
                      :value="tva.tauxTva">
                {{ tva.tauxTva | formatPercent }}
              </option>
            </select>
          </div>
        </b-field>
      </div>
    </div>

    <div class="pdl-10px" v-if="isProduitTlpeOuHonoraire"
         :class="[{ 'tlpe-first-line': indexLigne === 0,
    'tlpe-not-first-line': indexLigne !== 0, }]">
      <qd-switch v-model="ligneCommande.calculAutomatiqueTlpe" class="has-text-icon-more"
      @input="makeCalculAutomatique" :disabled="disabled">
        {{ $t('detail.article.calculAutoTlpe') }}
      </qd-switch>
    </div>
    <div v-else class='dates'>

    </div>
    <div class="pdl-10px mgl-5px columns dates pdt-10px" v-if="afficherObjectif">
      <b-field :label="$t('detail.article.montantFace')"
                 custom-class="is-size-7 is-marginless has-text-link ellipsis">
        <input-currency
          style='--width: 70px;'
          disabled
          :value="getMontantFace(ligneCommande)"
          isNumber="true">
        </input-currency>
      </b-field>
      <b-field :label="$t('detail.article.objectif')"
                 custom-class="is-size-7 is-marginless has-text-link ellipsis pdl-15px"
                 v-if="disponibilite">
        <input-currency
          :class="{'objectifRouge': !objectifValide && disponibilite.objectif,
            'objectifVert': objectifValide && disponibilite.objectif}"
          style='--width: 70px;'
          disabled
          :value="disponibilite.objectif"
          isNumber="true"
          class="pdl-15px">
        </input-currency>
      </b-field>
    </div>

    <div class='commandes__fin-ligne'
         :class="{ 'mgt-7px' : isFirstLigne($t('detail.article.TauxTva')) === null}">
      <div class="has-text-weight-semibold" :class="mustBeItalicAndThrough">
        <span v-if="ligneCommande.totalHt" class="is-fullwidth ellipsis">
          {{ligneCommande.totalHt | formatDevise}}
        </span>
        <span v-else> {{ 0.00 | formatDevise }} </span>
      </div>
      <div></div>
      <div>
        <a @click="supprimerProduit()"
           :class="{ disabled: isLigneRegroupementReseauInCreateCommandeFromDevis
           || ligneCommande.calculAutomatiqueTlpe || disabled || !canDelete
           || isLigneLocationOfReseauInDevisWithValidationModifBlocage }">
          <b-icon
            icon="delete-forever"
            type="is-danger">
          </b-icon>
        </a>
      </div>
    </div>

  </div>

  <b-modal v-model="isRemisesOpen"
    has-modal-card
    class="modal"
    @close="cancelRemise()">
    <app-lignes-remise
      :ligneRegroupement="ligneRegroupement"
      :ligneCommande="ligneCommande"
      :qteFacesPrevues="ligneRegroupement.ligneReseau
        ? ligneRegroupement.ligneReseau.qteFacesSouhaitees : 0"
      :isReseauTempo="ligneRegroupement.typeProduit === CATEGORIE_REGROUPEMENT"
      :cgvs="ligneRegroupement.produit.cgvs"
      @validationRemise="validationRemise"
      @cancelRemise="cancelRemise()" />
  </b-modal>
  <b-modal v-model="openPopUpCalculette"
           has-modal-card
           width="550px"
           class="modal">
    <pop-up-calculette :lignes-commande="lignesCommande"
                       :index-ligne="indexLigne"
                       :libelle-ligne="ligneCommande.libelle"
                       @calcul="calcul">
    </pop-up-calculette>
  </b-modal>

</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import inputCurrency from '@/components/general/inputCurrency';
import lignesRemise from '@/components/devisCommandes/editionDevisCommande/lignesRemise';
import * as devisConf from '@/configuration/devisConf';
import {
  getAllProductDivers,
  getAllProductLocation,
  getAllProduitEncart,
} from '@/services/devisCommandes/getAllProduct';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import * as apiProduitFace from '@/api/produit/produitFace';
import * as apiProduitRegroupement from '@/api/produit/produitReseau';
import * as apiProduitRegroupementNumerique from '@/api/produit/produitReseauNumerique';
import * as apiProduitEcranNumerique from '@/api/produit/produitNumerique';
import * as produitConf from '@/configuration/catalogue/produitConf';
import getDateAnneeSemaine from '@/services/devisCommandes/getDateAnneeSemaine';
import {
  SANS_SUITE, INDISPONIBLE, ANNULATION,
  BLOQUE,
  BLOQUE_COMMANDE,
} from '@/configuration/optionBlocage/optionBlocage';
import isLigneRegroupement from '@/services/devisCommandes/isLigneRegroupement';
import deleteLignesEcheanciersInutiles from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';
import { updateTarifProduitDiversTlpe, setPrixUnitaireTlpe } from '@/services/devisCommandes/updateTarifProduitDiversTlpe';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import messageErreur from '@/services/general/messageErreur';
import popUpCalculette from '@/components/devisCommandeFacture/lignesCommande/p_calculette';
import updateInfoSousLigneRegroupement from '@/services/dcf/lignesDCF/updateInfoSousLigneRegroupement';
import calculArrondi from '@/services/calcul/calculArrondi';
import { MODE_CALCUL_MANUEL } from '@/configuration/tiers/tiersConf';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import * as gestionTarifUnitaire from '@/services/devisCommandes/ligneCommande/gestionTarifUnitaire';
import genererCommentaireVenteForLigne from '@/services/devisCommandes/ajoutProduit/genererCommentaireVente';
import estDemandeManuelle from '@/services/devisCommandes/estDemandeManuelle';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import getExonerationTva from '@/services/tiers/getExonerationTva';

const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'sousligneRegroupement',
  props: {
    lignesCommande: Array,
    ligneCommande: Object,
    error: Boolean,
    ligneRegroupement: Object,
    indexLigne: Number,
    isCreditNote: Boolean,
    devisCommande: Object,
    ouverturePopup: Boolean,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
    disponibilite: {
      type: Object,
      required: false,
      default: null,
    },
    modulePresseActive: {
      type: Boolean,
      required: true,
    },
    periodeTotalCalculTlpeAuto: {
      type: Boolean,
      required: true,
    },
    activationYield: {
      type: Boolean,
      required: true,
    },
    regimesTva: {
      type: Array,
      required: true,
    },
  },
  components: {
    inputCurrency,
    appLignesRemise: lignesRemise,
    popUpCalculette,
  },
  data() {
    return {
      typesProduit: [],
      oldTypeRemise: null,
      typeRemiseLocal: null,
      keepFirst: false,
      openOnFocus: false,
      fetched: false,
      listeTarif: devisConf.DEVIS_COMMANDE_TARIF,
      listeSaisiesRemise: devisConf.LISTE_SAISIES,
      listeTypeRemiseLigne: devisConf.LISTE_TYPE_REMISE_LIGNE,
      listeUniteQuantite: devisConf.LISTE_UNITES,
      isRemisesOpen: false,
      location: produitConf.CATEGORIE_LOCATION,
      CATEGORIE_REGROUPEMENT: produitConf.CATEGORIE_REGROUPEMENT,
      openPopUpCalculette: false,
    };
  },
  computed: {
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    regimeTva() {
      return this.regimesTva.filter((tva) => {
        return tva.actif || this.ligneCommande.tauxTva === tva.tauxTva;
      });
    },
    isProduitPresse() {
      return this.ligneRegroupement && this.ligneRegroupement.produit
        && this.ligneRegroupement.produit.cgvs && this.ligneRegroupement.produit.cgvs.length > 0
        && (this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_PRESSE
        || this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_AUTRE
        || this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_SPONSORING
        || this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_SALON);
    },

    getListeTypeRemise() {
      if (this.isProduitPresse) {
        return this.listeTypeRemiseLigne.filter((typeRemise) => {
          return typeRemise.code === devisConf.PERSONALISE;
        });
      }
      return this.listeTypeRemiseLigne;
    },
    getRemiseTvaDefaut() {
      const agenceFind = this.agenceActive.find((agence) => {
        return agence.agenceId === this.devisCommande.agenceId;
      });
      if (!agenceFind || !agenceFind.regimeTvaId) return null;
      const regimeFind = this.regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    isProduitTlpeOuHonoraire() {
      return ((this.isProduitTlpe && this.hasProduitLocation)
        || this.isProduitHonoraire);
    },
    isLigneRegroupementReseauInCreateCommandeFromDevis() {
      return (this.devisCommande.referenceId
        && this.devisCommande.type === devisConf.TYPE_COMMANDE
        && this.ligneCommande.typeProduit === produitConf.CATEGORIE_LOCATION
        && isLigneRegroupement(this.devisCommande, this.ligneCommande.referenceRegroupement));
    },
    mustBeItalicAndThrough() {
      if (this.devisCommande.type === devisConf.TYPE_DEVIS) {
        if (isLigneRegroupement(this.devisCommande, this.ligneCommande.referenceRegroupement)
          && (this.ligneCommande.etatObtenu === SANS_SUITE
            || this.ligneCommande.etatObtenu === INDISPONIBLE
            || this.ligneCommande.etatObtenu === ANNULATION)) {
          return { 'is-italic': true, textDecorationLineThrough: true };
        }
      }
      return {};
    },
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    isProduitTlpe() {
      return !!(this.ligneCommande.produit && this.ligneCommande.produit.produitDivers
        && this.ligneCommande.produit.produitDivers.tlpe);
    },
    isProduitHonoraire() {
      return !!(this.ligneCommande.produit && this.ligneCommande.produit.produitDivers
        && this.ligneCommande.produit.produitDivers.honoraire
        && this.ligneCommande.modeCalculHonoraire
        && this.devisCommande.intervenants.length > 0
        && this.ligneCommande.modeCalculHonoraire.modeCalcul !== MODE_CALCUL_MANUEL);
    },
    hasProduitLocation() {
      const hasLocation = this.ligneRegroupement.lignesCommande.filter((el) => {
        return el.typeProduit === produitConf.CATEGORIE_LOCATION;
      }).length > 0;
      if (!hasLocation) {
        this.ligneRegroupement.lignesCommande.forEach((el) => {
          if (el.typeProduit === produitConf.CATEGORIE_DIVERS && el.produit.produitDivers
            && el.produit.produitDivers.tlpe
            && el.calculAutomatiqueTlpe) {
            el.calculAutomatiqueTlpe = false;
          }
        });
      }
      return hasLocation;
    },
    unite() {
      const uniteVente = this.listeUniteQuantite.find((unite) => {
        return unite.code === this.ligneCommande.uniteVente;
      });
      if (uniteVente) {
        return uniteVente.initiale;
      }
      return '';
    },
    valeurPourcentage: {
      get() {
        return remiseF2B.toMontantRemiseFront(
          this.ligneCommande.typeRemise, this.ligneCommande.remise,
        );
      },
      set(value) {
        remiseF2B.fromMontantRemiseFront(this.ligneCommande, this.typeRemiseLocal, value);
      },
    },
    typeRemiseInitial() {
      const typeRemise = this.listeTypeRemiseLigne.find((type) => {
        return type.code === this.typeRemiseLocal;
      });
      if (typeRemise) {
        return typeRemise.initiale;
      }
      return '';
    },
    afficherObjectif() {
      return this.activationYield && this.ligneCommande.typeProduit === this.location
        && this.ligneRegroupement.typeProduit === this.CATEGORIE_REGROUPEMENT;
    },
    objectifValide() {
      const montantFace = this.getMontantFace(this.ligneCommande);
      return montantFace >= this.disponibilite.objectif;
    },
    interdireModificationBlocageCLGActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key);
    },
    isLigneLocationOfReseauInDevisWithValidationModifBlocage() {
      return (estDemandeManuelle() && this.interdireModificationBlocageCLGActive
        && this.ligneRegroupement.id
        && [devisConf.TYPE_DEVIS, devisConf.TYPE_COMMANDE].includes(this.devisCommande.type)
        && this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_REGROUPEMENT
        && this.ligneCommande.typeProduit === produitConf.CATEGORIE_LOCATION
        && [BLOQUE, BLOQUE_COMMANDE].includes(this.ligneRegroupement.etatObtenu));
    },
    isCommandeAchatBailleur() {
      return this.devisCommande.type === devisConf.TYPE_COMMANDE
        && this.devisCommande.module === devisConf.MODULE_BAIL;
    },
  },
  async mounted() {
    if (!this.ligneCommande.typeRemise && !this.ligneCommande.remise) {
      remiseF2B.fromTypeRemiseFront(
        this.ligneCommande, devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE,
      );
    }
    if (!this.ligneCommande.produit) {
      this.ligneCommande.produit = {
        reference: '',
      };
    }
    this.typeRemiseLocal = remiseF2B.toTypeRemiseFront(
      this.ligneCommande.typeRemise, this.ligneCommande.remise,
    );
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    annonceurWithExonerationTva(ligne) {
      const annonceurExonererTva = this.devisCommande.intervenants.some((int) => {
        return int.annonceur && getExonerationTva(int);
      });
      if (annonceurExonererTva) ligne.tauxTva = 0;
      return annonceurExonererTva;
    },
    getMontantBrut(ligne) {
      if (ligne.uniteVente === devisConf.POURCENTAGE) {
        return calculArrondi(ligne.prixUnitaire * ligne.quantite / 100);
      }
      return calculArrondi(ligne.prixUnitaire * ligne.quantite);
    },
    getPrixUnitaireNet(ligne) {
      if (ligne.quantite === 0 || !ligne.quantite) return 0;
      return calculArrondi(ligne.totalHtAvecLigneRemise / ligne.quantite);
    },
    getMontantFace(ligne) {
      if (ligne.ligneReseau.qteFacesSouhaitees === 0
        || !ligne.ligneReseau.qteFacesSouhaitees
        || typeof ligne.ligneReseau.qteFacesSouhaitees === 'string') return 0;
      return calculArrondi(ligne.totalHtAvecLigneRemise / ligne.ligneReseau.qteFacesSouhaitees);
    },
    async makeCalculAutomatique(calculAuto) {
      if (this.isProduitTlpe) {
        await this.calculAutomatiqueTlpe(calculAuto);
      }
      gestionTarifUnitaire.toggleTarifUnitaire(this.ligneRegroupement);
      this.calcul();
    },
    async calculAutomatiqueTlpe(calculAuto) {
      try {
        if (!calculAuto) return;
        await calculTlpe(
          this.ligneRegroupement,
          this.devisCommande.type === devisConf.TYPE_FACTURE,
          this.periodeTotalCalculTlpeAuto,
          this.devisCommande.repartitionPayeurSurFacture,
        );
        this.calcul();
      } catch (e) {
        this.ligneRegroupement.lignesCommande.forEach((el) => {
          if (el.typeProduit === produitConf.CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
            && el.produit.produitDivers && el.produit.produitDivers.tlpe) {
            el.prixUnitaire = 0;
          }
        });
        this.calcul();
      }
    },
    isFirstLigne(i18nTrad) {
      if (this.indexLigne === 0) return i18nTrad;
      return null;
    },
    searchProduct: debounce(async function searchProductC() {
      if (this.ligneCommande.produit.reference
        && this.ligneCommande.produit.reference.length >= 3) {
        this.fetched = true;
        if (this.ligneCommande.typeProduit === produitConf.CATEGORIE_ENCART) {
          this.typesProduit = await getAllProduitEncart(this.ligneCommande.produit.reference,
            this.ligneRegroupement);
        } else if (this.ligneCommande.typeProduit === produitConf.CATEGORIE_LOCATION) {
          this.typesProduit = await getAllProductLocation(this.ligneCommande.produit.reference,
            this.$route.params.id ? this.devisCommande.societeId : this.societeActiveId);
        } else {
          this.typesProduit = await getAllProductDivers(this.ligneCommande.produit.reference,
            this.$route.params.id ? this.devisCommande.societeId : this.societeActiveId);
        }
      } else {
        this.typesProduit = [];
        this.fetched = false;
      }
    }, 500),
    async selectedProduct(option) {
      if (!option) {
        return;
      }
      updateInfoSousLigneRegroupement(option, this.ligneCommande,
        this.ligneCommande.produitId === null, this.getRemiseTvaDefaut);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateModeCalculHonoraireLigneCommandeHonoraire(
          this.devisCommande.lignesCommande,
          this.devisCommande.intervenants,
        );
        gestionTarifUnitaire.toggleTarifUnitaire(this.ligneRegroupement);
        this.calcul();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
      if (this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_PRESSE
          && option.type === produitConf.CATEGORIE_ENCART) {
        this.ligneRegroupement.dateDebut = null;
        this.ligneRegroupement.dateFin = null;
        this.ligneRegroupement.parution = null;
        this.ligneRegroupement.parutionId = null;
      }
      genererCommentaireVenteForLigne(option.produit, this.ligneCommande, this.lignesCommande);
      if (this.ligneCommande.produitId !== null) return;
      let produitRegroupement = null;
      let dateDebut = new Date();
      if (this.ligneRegroupement.dateDebut) {
        dateDebut = this.ligneRegroupement.dateDebut;
      } else if (this.ligneRegroupement.ligneReseau
        && this.ligneRegroupement.ligneReseau.anneeSemaine) {
        dateDebut = getDateAnneeSemaine(this.ligneRegroupement.ligneReseau.anneeSemaine);
      }
      switch (this.ligneRegroupement.typeProduit) {
        case produitConf.CATEGORIE_UNITAIRE:
          produitRegroupement = (await apiProduitFace
            .get(this.ligneRegroupement.produitId))
            .data.result;
          break;
        case produitConf.CATEGORIE_REGROUPEMENT:
          produitRegroupement = (await apiProduitRegroupement
            .get(this.ligneRegroupement.produitId))
            .data.result;
          break;
        case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
          produitRegroupement = (await apiProduitRegroupementNumerique
            .get(this.ligneRegroupement.produitId))
            .data.result;
          break;
        case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
          produitRegroupement = (await apiProduitEcranNumerique
            .get(this.ligneRegroupement.produitId))
            .data.result;
          break;
        default: break;
      }
      if (produitRegroupement) {
        const liaison = returnLiaisonTarif(produitRegroupement, option.id, dateDebut);
        if (liaison) {
          this.ligneCommande.typeProduit = liaison.produitEnfant.supportCommercial.categorieVente;
          if (liaison.prixUnitaire) {
            this.ligneCommande.prixUnitaire = liaison.prixUnitaire;
          }
        }
      }
      if (this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_UNITAIRE
        || this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_LC) {
        setPrixUnitaireTlpe(this.ligneRegroupement.lignesCommande.filter((ligneCommande) => {
          return ligneCommande.produit
            && ligneCommande.produit.produitDivers && !ligneCommande.calculAutomatiqueTlpe
            && ligneCommande.produit.produitDivers.tlpe;
        }), this.ligneRegroupement.produit.liaisonsTarif);
        updateTarifProduitDiversTlpe(
          this.ligneRegroupement.dateDebut,
          this.ligneRegroupement.dateFin,
          this.ligneRegroupement.lignesCommande.filter((ligneCommande) => {
            return ligneCommande.produit
              && ligneCommande.produit.produitDivers && !ligneCommande.calculAutomatiqueTlpe
              && ligneCommande.produit.produitDivers.tlpe;
          }),
        );
      }
      this.calcul();
    },
    changeTva() {
      this.$emit('changementTva');
      this.calcul();
    },
    calcul() {
      this.$emit('reloadTotalHt');
    },
    estRemisePersonalisee() {
      return this.ligneCommande.typeRemise === devisConf.PERSONALISE;
    },
    supprimerProduit() {
      this.lignesCommande.splice(this.lignesCommande.indexOf(this.ligneCommande), 1);
      deleteLignesEcheanciersInutiles(this.devisCommande);
      this.$emit('reloadTotalHt');
    },
    changerUnite(props) {
      this.ligneCommande.uniteVente = props.code;
      this.calcul();
    },
    updateTypeRemiseLocal() {
      this.typeRemiseLocal = remiseF2B.toTypeRemiseFront(
        this.ligneCommande.typeRemise, this.ligneCommande.remise,
      );
    },
    changerTypeRemise(props) {
      this.oldTypeRemise = this.typeRemiseLocal;
      this.typeRemiseLocal = props.code;
      remiseF2B.fromTypeRemiseFront(this.ligneCommande, this.typeRemiseLocal);
      if (this.estRemisePersonalisee()) {
        this.isRemisesOpen = true;
      } else {
        this.ligneCommande.lignesRemise = [];
        this.ligneCommande.remise = 0;
      }
      this.calcul();
    },
    validationRemise(ligne) {
      this.ligneCommande.lignesRemise = ligne.lignesRemise;
      this.isRemisesOpen = false;
      this.$emit('reloadTotalHt');
    },
    cancelRemise() {
      this.typeRemiseLocal = this.oldTypeRemise;
      remiseF2B.fromTypeRemiseFront(this.ligneCommande, this.typeRemiseLocal);
      this.isRemisesOpen = false;
    },
  },
};
</script>
